import React from 'react'
import { Form, FormInstance } from 'antd'
import SelectPrefixForm from 'components/SelectPrefixForm/SelectPrefix'
import { filterOptions } from 'util/funcionesNews'
import { FIELDS_NAMES_RECURSO } from '../interfaces/FieldNamesRecurso'
import { EmpresaOption, OrganizacionOption, RegionalOption } from '../hooks/useUbicacionEstaciones'

interface PasoUbicacionEstacionesProps {
  form: FormInstance
  organizacionesOptions: OrganizacionOption[]
  regionalesOptions: RegionalOption[]
  loadingRegionales: boolean
  empresasOptions: EmpresaOption[]
  loadingEmpresas: boolean
  autoseleccionadas: boolean
  onChangeOrganizacion: (value: number | null) => void
  onChangeRegionales: (values: number[]) => void
  soloLectura?: boolean
}

const PasoUbicacionEstaciones = ({
  form,
  organizacionesOptions,
  regionalesOptions,
  loadingRegionales,
  empresasOptions,
  loadingEmpresas,
  autoseleccionadas,
  onChangeOrganizacion,
  onChangeRegionales,
  soloLectura = false,
}: PasoUbicacionEstacionesProps) => {
  const organizacionSeleccionada: number | null = Form.useWatch(FIELDS_NAMES_RECURSO.ORGANIZACION, form) ?? null
  const regionalesSeleccionadas: number[] = Form.useWatch(FIELDS_NAMES_RECURSO.REGIONALES, form) ?? []
  const empresasSeleccionadas: number[] = Form.useWatch(FIELDS_NAMES_RECURSO.EMPRESAS, form) ?? []

  return (
    <>
      {!soloLectura && (
        <>
          <SelectPrefixForm
            name={FIELDS_NAMES_RECURSO.ORGANIZACION}
            options={organizacionesOptions}
            prefixText="Organización"
            allowClear
            className="select-gray"
            value={organizacionSeleccionada}
            filterOption={filterOptions}
            placeholder="Seleccione su organización (opcional)"
            onChange={onChangeOrganizacion}
          />

          <div style={{ marginTop: 12 }}>
            <SelectPrefixForm
              name={FIELDS_NAMES_RECURSO.REGIONALES}
              mode="multiple"
              options={regionalesOptions}
              loading={loadingRegionales}
              prefixText="Regional"
              allowClear
              className="select-gray"
              maxTagCount="responsive"
              value={regionalesSeleccionadas}
              filterOption={filterOptions}
              placeholder="Seleccione regional (opcional)"
              onChange={onChangeRegionales}
            />
          </div>
        </>
      )}

      <div style={{ marginTop: soloLectura ? 0 : 12 }}>
        <SelectPrefixForm
          name={FIELDS_NAMES_RECURSO.EMPRESAS}
          mode="multiple"
          options={empresasOptions}
          loading={loadingEmpresas}
          prefixText="Estación"
          required
          disabled={soloLectura}
          className="select-gray"
          maxTagCount="responsive"
          value={empresasSeleccionadas}
          filterOption={filterOptions}
          placeholder="Seleccione las estaciones"
        />
        {!soloLectura && empresasOptions.length === 0 && !loadingEmpresas && (
          <span style={{ fontSize: 12, color: '#8c8c8c', marginTop: 4, display: 'block' }}>
            No hay estaciones disponibles para la selección actual.
          </span>
        )}
        {soloLectura && (
          <span style={{ fontSize: 12, color: '#8c8c8c', marginTop: 4, display: 'block' }}>
            La estación de un recurso no se cambia. Si lo necesitas en otra, créalo allá.
          </span>
        )}
      </div>

      {!soloLectura && autoseleccionadas && empresasSeleccionadas.length > 0 && (
        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 12 }}>
          Se seleccionaron automáticamente las {empresasSeleccionadas.length} estación(es) de la
          {regionalesSeleccionadas.length > 0 ? ' regional' : ' organización'}. Puedes quitar las que no apliquen.
        </div>
      )}

      {!soloLectura && empresasSeleccionadas.length > 0 && (
        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
          El recurso se creará una vez en cada una de las {empresasSeleccionadas.length} estación(es)
          seleccionada(s).
        </div>
      )}
    </>
  )
}

export default PasoUbicacionEstaciones
